import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { kebabCase, split, last, first, each } from 'lodash';
import { NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Fa from 'react-fontawesome';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import ProgressBar from '../../../../components/progress-bar';
// Import Actions
import { loadBenchmarks } from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import BenchmarkDetailPage from './BenchmarkDetailPage';

class BenchmarkIndexPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
      benchmarks: [],
    };
  }

  componentDidMount() {
    this.loadBenchmarks();
  }

  loadBenchmarks() {
    this.setState({ loading: true, loaded: false, benchmarks: [] }, () => {
      this.props.dispatch(loadBenchmarks(this.props.type))
        .then(
          ({ benchmarks }) => {
            each(benchmarks, (benchmark) => {
              benchmark.subType = kebabCase(last(split(benchmark.type, ('/'))));
            });
            this.setState({ loading: false, loaded: true, benchmarks });
          },
        );
    });
  }

  renderResults() {
    const { benchmarks } = this.state;
    const { type, location: { pathname } } = this.props;
    const firstBenchmark = first(benchmarks);

    return (
      <div>
        {type !== 'forecasts' && 
          <div>
            <ul className="nav nav-tabs">
              {benchmarks.map((comp) => {
                return (
                  <LinkContainer key={comp._id} to={`/setup/benchmarks/${type}/${comp.subType}`}>
                    <NavItem>{comp.name}</NavItem>
                  </LinkContainer>
                );
              })}
            </ul>
            <p />
          </div>
        }
        {(pathname === `/setup/benchmarks/${type}` && firstBenchmark !== undefined && firstBenchmark !== null && <Redirect to={`/setup/benchmarks/${type}/${firstBenchmark.subType}`} />)}
        <div className="well">
          <Fa name="info-circle" /> Only opportunities/deals that match the filter(s) below will be included in the benchmark calculation:
        </div>
        <Switch>
          {benchmarks.map((comp) => {
            return (
              <Route
                key={comp._id}
                path={`/setup/benchmarks/${type}/${comp.subType}`}
                render={(props) => {
                  return <BenchmarkDetailPage key={comp._id} type={type} subType={comp.subType} {...props} />;
                }}
              />
            );
          })}
        </Switch>
      </div>
    );
  }

  render() {
    const { organization } = this.props;
    const isDemo = organization && organization.is_demo;
    const { loading, loaded } = this.state;
    return (
      <div>
        {isDemo &&
          <div className="alert alert-warning">
            This is a demo organization, please switch back to the original organization to change the settings.
          </div>
        }
        {!isDemo &&
          <div>
            {loading && <ProgressBar />}
            {!loading && loaded && this.renderResults()}
          </div>
        }
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

BenchmarkIndexPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    is_demo: PropTypes.bool,
  }).isRequired,
  type: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

BenchmarkIndexPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(BenchmarkIndexPage));
